import { TableComponent, ColumnComponent } from '@/store/form/component.js'

const findVueMixin = {
  methods: {
    /** 递归获取所有控件vue对象 */
    findAllVue (component, arrTree = []) {
      component.$children.forEach(el => {
        if (el.component && (el.component instanceof ColumnComponent || el.component instanceof TableComponent)) {
          arrTree.push(el)
        }
        this.findAllVue(el, arrTree)
      })
      return arrTree
    },
    /** 递归获取所有vue对象 */
    findAllVue2 (component, arrTree = []) {
      component.$children.forEach(el => {
        arrTree.push(el)
        this.findAllVue2(el, arrTree)
      })
      return arrTree
    },
    /** 通过控件id找到对应vue对象 */
    findVueByComponentId (id) {
      return this.findAllVue(this).find(n => n.component.id === id)
    },
    getElement (componentId) {
      return this.findAllVue(this).find(it => it.component.componentId === componentId)
    },
    // 根据归档id找到对应vue对象
    findVueBycolumnId (columnId) {
      return this.findAllVue(this).find(n => n.component.archive.columnId === columnId)
    },
    /** 找到最上层的rc-form对象 */
    findParentFormComponent (component) {
      if (component.component && (component.component instanceof ColumnComponent || component.component instanceof TableComponent) && component.component.componentType === 'rc-form') {
        return component
      } else if (component.$parent) {
        return this.findParentFormComponent(component.$parent)
      }
    },
    /** 子控件中查找所有同表单下的vue对象 */
    findAllVueByChildren (component, arrTree = []) {
      let parentFormComponent = this.findParentFormComponent(component)
      if (parentFormComponent) {
        arrTree = parentFormComponent.findAllVue(parentFormComponent)
      }
      return arrTree
    }
  }
}

export { findVueMixin }



// WEBPACK FOOTER //
// ./src/components/form/runtime/components/findVue.js